import React, { useState, useCallback, useEffect } from 'react'
import { Modal, LegacyCard, TextField } from '@shopify/polaris'
import i18n from '../../translations/i18n'

function CancelSubscription(props) {
  const { t } = i18n
  const confirmRemove = () => {
    props.cancelSubscription()
  }

  return (
    <div>
      <Modal
        open={props.showModal}
        onClose={props.handleClose}
        title={props.title}
        primaryAction={{
          content: t('yes-cancel'),
          destructive: true,
          onAction: confirmRemove,
        }}
      >
        <div style={{ padding: 20 }}>{t('sure-to-cancel-subscription')}</div>
      </Modal>
    </div>
  )
}

export default CancelSubscription
